<template>
  <div>
    Demo2 对象数组数据绑定checkbox id字段 OK的
    <div>
      <v-btn @click="handleSelectAll">
        全选/取消全选
      </v-btn>
      <hr>
      <v-checkbox
        v-for="authObj in authList"
        :key="authObj.id"
        v-model="selected"
        :value="authObj.id"
        class="mr-4"
        style="display: inline-flex;width: calc(22%);"
      >
        <template #label>
          {{ authObj.name }}
        </template>
      </v-checkbox>
      <hr>
      选择的数据长度: {{ selected.length }}
      <hr>
      selected: {{ selected }}
    </div>    
  </div>
</template>

<script>

export default {
  data() {
    return {
      selected: [
      ],
      authList: [
        {
          id: 1,
          name: '权限1',
          code: '1'
        },
        {
          id: 2,
          name: '权限2',
          code: '2'
        },
        {
          id: 3,
          name: '权限3',
          code: '3'
        },
      ]
    };
  },
  mounted() {
    // 循环10个 { id: index, name: '权限' + index, code: index }
    this.selected = Array.from({ length: 10 }, (v, i) => ({ id: i + 1, name: `权限${i + 1}`, code: i + 1 })).map(item => item.id);
  },
  methods: {
    handleSelectAll() {
      const selList = [...this.selected];
      // 通过 id 判断 this.selected 全包含 this.authList（ this.selected 元素 可能大于 this.authList
      if(this.authList.every(item => selList.includes(item.id))) {
        // 如果全包含，就移除this.authList.map(item => item.id)
        this.selected = selList.filter(item => !this.authList.map(item => item.id).includes(item));
      } else {
        // 全选，就添加this.authList.map(item => item.id)
        this.selected = selList
          .filter(item => !this.authList.map(item => item.id).includes(item))
          .concat(this.authList.map(item => item.id));
      }

    },
  },
};
</script>

<style>

</style>
